var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"separacion_contenedores",on:{"click":_vm.agregarNueva}},[_vm._v("Agregar nueva factura")])
}
var staticRenderFns = []

export { render, staticRenderFns }